// extracted by mini-css-extract-plugin
module.exports = {"elMain":"templates_elMain_3YWIm","searchWrapper":"templates_searchWrapper_271AX"};